"use client";

import Image from "next/image";
import Link from "next/link";
import { useState } from "react";

export default function Footer() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsSubmitting(true);
    setIsError(false);

    try {
      const formData = new FormData(event.currentTarget);
      const response = await fetch(
        `https://formspree.io/f/${
          process.env.NEXT_PUBLIC_EMAIL_NEWSLETTER_FORM || ""
        }`,
        {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json",
          },
        }
      );

      if (response.ok) {
        setIsSuccess(true);
      } else {
        setIsError(true);
        console.error("Form submission failed");
      }
    } catch (error) {
      setIsError(true);
      console.error("Form submission error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer>
      <div className="flex justify-center w-full p-10 px-[18px] lg:px-18">
        <div className="flex flex-col items-center justify-center w-full max-w-[1200px] gap-14">
          <div className="flex xl:flex-row flex-col gap-[38px] w-full justify-between">
            <div className="flex flex-col gap-3">
              <div className="w-[207px] lg:w-[265px]">
                <Link href="/">
                  <Image
                    src="/images/listkit-logo.webp"
                    alt="Listkit Logo"
                    width={415}
                    height={120}
                    className="w-full"
                  />
                </Link>
              </div>
              <p className="text-sm lg:text-[16px] leading-5 lg:leading-[22px] text-[#0D2A4C99] tracking-tight font-medium">
                The fastest way to book B2B sales calls
              </p>
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-12">
              <div className="flex flex-col gap-4 lg:gap-5">
                <p className="text-[#0D2A4C] font-semibold tracking-tighter text-xl lg:text-2xl leading-[22px] lg:leading-6">
                  Comparison
                </p>
                <div className="flex flex-col gap-3.5 lg:gap-4">
                  <Link
                    href="/comparison-listkit-vs-apollo"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    ListKit vs Apollo
                  </Link>
                  <Link
                    href="/comparison-listkit-vs-zoominfo"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    ListKit vs Zoominfo
                  </Link>
                  <Link
                    href="/comparison-listkit-vs-lusha"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    ListKit vs Lusha
                  </Link>
                  <Link
                    href="/comparison-listkit-vs-clearbit"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    ListKit vs Clearbit
                  </Link>
                  <Link
                    href="/comparison-listkit-vs-cognism"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    ListKit vs Cognism
                  </Link>
                  <Link
                    href="/comparison-listkit-vs-rocketreach"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    ListKit vs RocketReach
                  </Link>
                  <Link
                    href="/comparison-listkit-vs-snov-io"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    ListKit vs Snov.io
                  </Link>
                  <Link
                    href="/comparison-listkit-vs-seamless"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    ListKit vs Seamless
                  </Link>
                </div>
              </div>
              <div className="flex flex-col gap-4 lg:gap-5">
                <p className="text-[#0D2A4C] font-semibold tracking-tighter text-xl lg:text-2xl leading-[22px] lg:leading-6">
                  Products
                </p>
                <div className="flex flex-col gap-3.5 lg:gap-4">
                  <Link
                    href="/triple-verified-leads"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    Leads
                  </Link>
                  <Link
                    href="/unlimited-intent-data"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    Intent Data
                  </Link>
                  <Link
                    href="/cold-email-setup"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    Email Sending
                  </Link>
                  {/* <Link
                    href="/"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    Domain Setup
                  </Link>
                  <Link
                    href="/"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    Website Visitors
                  </Link>
                  <Link
                    href="/"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    AI Agents
                  </Link> */}
                </div>
              </div>
              <div className="flex flex-col gap-4 lg:gap-5">
                <p className="text-[#0D2A4C] font-semibold tracking-tighter text-xl lg:text-2xl leading-[22px] lg:leading-6">
                  Resources
                </p>
                <div className="flex flex-col gap-3.5 lg:gap-4">
                  <Link
                    href="/blog"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    Blog
                  </Link>
                  <Link
                    href="/case-studies"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    Case Studies
                  </Link>
                  <Link
                    href="/opt-in-for-lead-magnet"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    Lead Magnet
                  </Link>
                  <Link
                    href="/wall-of-love"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    Testimonials
                  </Link>
                  {/* <Link
                    href="/"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    Website Visitors
                  </Link> */}
                  <Link
                    href="/cold-email-setup"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    Cold Email Mastery
                  </Link>
                </div>
              </div>
              <div className="flex flex-col gap-4 lg:gap-5">
                <p className="text-[#0D2A4C] font-semibold tracking-tighter text-xl lg:text-2xl leading-[22px] lg:leading-6">
                  Company
                </p>
                <div className="flex flex-col gap-3.5 lg:gap-4">
                  <Link
                    href="/about"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    Our Team
                  </Link>
                  <Link
                    href="/job"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    Careers
                  </Link>
                  <Link
                    href="/affiliates"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    Affiliate Program
                  </Link>
                </div>
              </div>
              {/* <div className="flex flex-col gap-4 lg:gap-5">
                <p className="text-[#0D2A4C] font-semibold tracking-tighter text-xl lg:text-2xl leading-[22px] lg:leading-6">
                  Solutions
                </p>
                <div className="flex flex-col gap-3.5 lg:gap-4">
                  <Link
                    href="/cold-email-setup"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    Cold Email Setud
                  </Link>
                  <Link
                    href="/strategy-call"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    Strategy Call
                  </Link>
                  <Link
                    href="/"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    CRM Integrations
                  </Link>
                </div>
              </div> */}
              <div className="flex flex-col gap-4 lg:gap-5">
                <p className="text-[#0D2A4C] font-semibold tracking-tighter text-xl lg:text-2xl leading-[22px] lg:leading-6">
                  Support
                </p>
                <div className="flex flex-col gap-3.5 lg:gap-4">
                  <Link
                    href="https://docs.listkit.io/en/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    Help Centre
                  </Link>
                  <Link
                    href="https://docs.listkit.io/en/collections/12606631-dfy-plan-resources-guides-faqs"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    FAQs
                  </Link>
                  <Link
                    href="/about"
                    className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]"
                  >
                    Contact
                  </Link>
                </div>
              </div>
              <div className="flex flex-col gap-4 lg:gap-5 col-span-2">
                <p className="text-[#0D2A4C] font-semibold tracking-tighter text-xl lg:text-2xl leading-[22px] lg:leading-6">
                  Newsletter
                </p>
                <p className="text-[#0D2A4C99] font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]">
                  No spam, only useful information.
                </p>
                <div className="flex flex-col">
                  <form
                    onSubmit={handleSubmit}
                    className="relative w-full p-1.5 bg-[#F8F9FA] rounded-[100px] border border-[#0D2A4C0D] flex justify-between"
                  >
                    <input
                      className="focus-visible:outline-none focus-visible:ring-0 flex-1 pl-5"
                      maxLength={256}
                      name="Email-Newsletter"
                      placeholder="Email"
                      type="email"
                      id="Email-Newsletter"
                      required
                    />
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="bg-[#2A8DFF] disabled:opacity-85 px-[18px] lg:px-[22px] py-[11px] lg:py-[15px] rounded-[100px]"
                    >
                      <p className="text-sm lg:text-lg text-white tracking-tight font-semibold">
                        {isSubmitting ? "Please wait..." : "Subscribe"}
                      </p>
                    </button>
                  </form>
                  {isSuccess && (
                    <p className="text-green-800 pl-4 font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]">
                      Thank you! Your submission has been received!
                    </p>
                  )}
                  {isError && (
                    <p className="text-red-800 pl-4 font-medium tracking-tight text-sm lg:text-[16px] leading-[22px]">
                      Oops! Something went wrong while submitting the form.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="lg:pt-11 flex flex-col items-center lg:flex-row gap-8 justify-between w-full">
            <p className="text-[#0D2A4C99] tracking-tight text-center lg:text-start font-medium text-sm lg:text-[16px] lg:leading-[22px]">
              2025 — &copy;ListKit. All product trademarks, names, logos, and
              brands are property of their respective owners
            </p>
            <div className="flex gap-5">
              <Link
                className="text-[#0D2A4C99] tracking-tight text-center lg:text-start font-medium text-sm lg:text-[16px] lg:leading-[22px]"
                href="/privacy"
              >
                Privacy Policy
              </Link>
              <Link
                className="text-[#0D2A4C99] tracking-tight text-center lg:text-start font-medium text-sm lg:text-[16px] lg:leading-[22px]"
                href="/terms"
              >
                Terms
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
